var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrashDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.455 5.09h13.09V3.637H1.455v1.455zm11.218 9.455H3.327l-.923-8.727h11.192l-.923 8.727zM8 1.455a1.82 1.82 0 011.781 1.454H6.22A1.817 1.817 0 018 1.455zm6.91 1.454h-4.393A2.549 2.549 0 008 .727c-1.28 0-2.339.95-2.517 2.182H1.091c-.2 0-.364.163-.364.364v2.182c0 .2.163.363.364.363h.582l.965 9.13c.02.184.176.325.362.325h10c.186 0 .342-.14.362-.326l.965-9.129h.582c.2 0 .364-.163.364-.363V3.273a.364.364 0 00-.364-.364zm-4.29 10.544l.03.001a.364.364 0 00.363-.332l.492-5.819a.363.363 0 10-.724-.061l-.493 5.818c-.017.2.131.376.332.393m-5.27.002c.011 0 .021 0 .032-.002a.363.363 0 00.331-.393L5.22 7.242a.364.364 0 00-.725.061l.494 5.819c.016.19.175.333.362.333M8 13.429c.2 0 .364-.163.364-.364V7.35a.364.364 0 00-.727 0v5.716c0 .201.163.364.364.364"
  })));
}

export default __webpack_public_path__ + "47c66eef2a28215ab0402296788d342b.svg";
export { SvgIconTrashDark as ReactComponent };